/* ============================================================
 * NauticIQ marketing navbar behavior
 * Ported from Next.js Navbar.tsx (scroll state, mobile toggle,
 * same-page smooth hash scrolling)
 * ============================================================ */

(function () {
  'use strict';

  var nav = document.getElementById('nqNav');
  if (!nav) return;

  var mobilePanel = document.getElementById('nqNavMobile');
  var toggleBtn = document.getElementById('nqNavToggle');
  var langItem = mobilePanel ? mobilePanel.querySelector('.nq-nav__mobile-lang') : null;
  var langToggle = document.getElementById('nqNavLangToggle');
  var isOpen = false;
  var lockedScrollY = 0;

  // Scroll state (matches Next.js: scrolled after 12px).
  // Light pages keep the solid bar even at top (no contrast on mesh bg).
  function needsSolidNav() {
    return !!document.querySelector('.nq-page--contact, [data-nq-nav="solid"]');
  }

  function onScroll() {
    nav.classList.toggle('nq-nav--scrolled', needsSolidNav() || window.scrollY > 12);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  function setLangOpen(open) {
    if (!langItem || !langToggle) return;
    langItem.classList.toggle('is-open', open);
    langToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function lockPage() {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('nq-menu-open');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + lockedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockPage() {
    document.documentElement.classList.remove('nq-menu-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
  }

  function setOpen(open) {
    if (open === isOpen) return;
    var wasOpen = isOpen;
    isOpen = open;
    nav.classList.toggle('nq-nav--open', open);
    if (mobilePanel) {
      mobilePanel.classList.toggle('nq-open', open);
    }
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (wasOpen && !open) {
      setLangOpen(false);
      unlockPage();
    } else if (open) {
      lockPage();
    }
  }

  if (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      setOpen(!isOpen);
    });
  }

  if (langToggle) {
    langToggle.addEventListener('click', function () {
      setLangOpen(langToggle.getAttribute('aria-expanded') !== 'true');
    });
  }

  // Same-page hash links: smooth scroll without navigation
  function handleHashClick(e) {
    var href = this.getAttribute('href') || '';
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;

    var path = href.slice(0, hashIndex) || '/';
    var hash = href.slice(hashIndex + 1);
    var current = window.location.pathname.replace(/\/$/, '') || '/';
    var target = path.replace(/\/$/, '') || '/';
    if (current !== target || !hash) return;

    var el = document.getElementById(hash);
    if (!el) return;

    e.preventDefault();
    setOpen(false);
    el.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    window.history.replaceState(null, '', '#' + hash);
  }

  var links = document.querySelectorAll('.nq-nav__links a, .nq-nav__mobile a, [data-nq-page] a[href*="#"]');
  for (var i = 0; i < links.length; i++) {
    links[i].addEventListener('click', handleHashClick);
  }
})();
